import { createStoryboard } from "actions/storyboard";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";

import _ from 'lodash';
import cx from 'classnames';
import { getBaseUrl } from "services/util";
import {Loader} from "components/ApplicationLoader";
import styles from './template.module.scss';

export const CreateTemplatePage = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  let { template } = useParams();
  const { search } = useLocation();

  const creating = useSelector(state => _.get(state, 'storyboards.storyboard.creating'));
  const storyboard = useSelector(state => _.get(state, 'storyboards.storyboard.item'));

  useEffect(() => {
    const urlParams = new URLSearchParams(search);
    const name = urlParams.get('name');
    const list = urlParams.get('list');

    const request = {
      name: name,
      template: template,
      list: list,
    }

    dispatch(createStoryboard(request));
  }, []);

  useEffect(() => {
    if(!creating && storyboard){
      if(window.opener){
        window.opener.location.reload();
      }

      const page = _.get(storyboard, 'page.id');
      var url = `${baseUrl}/pages/${page}`;
      history.replace(url);
    }
  }, [creating, storyboard]);
  
  return (
    <div className={cx(styles.createStoryboardFromTemplate, styles.loading)}>
      <Loader className={styles.loadingAnimation} title="Creating storyboard...."/>
    </div>
  );
}